import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { LanguageSettings } from '@src/suite/common/services/language-settings';

export interface AttachmentErrorData {
    title: string;
    messages: string[];
}

@Component({
    selector: 'attachment-error',
    templateUrl: './attachment-error.html',
    styleUrls: ['./attachment-error.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        'class': 'st-attachment-error'
    }
})
export class AttachmentErrorComponent {

    constructor(
        public dialogRef: DialogRef<string>,
        @Inject(DIALOG_DATA) public data: AttachmentErrorData,
        public languageSettings: LanguageSettings
    ) {}

    cancel() {
        this.dialogRef.close();
    }
}
